import { useRef } from 'preact/hooks';
import { JSX } from 'preact';

const CopyToClipboard = ({ promocode }): JSX.Element => {
    const input = useRef<HTMLInputElement>(null);

    const copy = () => {
        input.current && input.current.select();
        document.execCommand('copy');
    };

    return (
        <form className='arc3-form'>
            <div className='arc3-form__input-wrapper btn-inside-input'>
                <input
                    class='arc3-typo--text-center'
                    type='text'
                    value={promocode}
                    autocapitalize='off'
                    autocorrect='off'
                    spellcheck='false'
                    readonly
                    ref={input}
                />
                {/* Temporary disabled until we have a better solution through CMS-13285 */}
                {/* <a class='copy-input no-link-style' onClick={copy}>
                    <Trans transKey='form.copyInput.copyText' />
                </a> */}
            </div>
        </form>
    );
};

export default CopyToClipboard;
